<template>
  <v-autocomplete
    v-model="selectedEmployeeCode"
    :items="filteredEmployees"
    :loading="loadingEmployees"
    :search-input.sync="employeeSearch"
    no-filter
    clearable
    label="Mã nhân viên"
    item-text="code"
    item-value="code"
    outlined
    dense
    required
    :rules="[v => !!v || 'Mã nhân viên là bắt buộc']"
    @input="$emit('input', $event)"
  >
    <!-- Custom dropdown item template -->
    <template v-slot:item="{ item }">
      <v-list-item-avatar size="32" class="mr-2">
        <v-img v-if="item.avatar" :src="item.avatar" />
        <span v-else class="white--text font-weight-bold" :style="{ backgroundColor: getAvatarColor(item.code) }">
          {{ item.name.charAt(0).toUpperCase() }}
        </span>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle>
          <span class="font-weight-bold">{{ item.code }}</span> - {{ item.department }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>

    <!-- Custom selection template -->
    <template v-slot:selection="{ item }">
      <v-list-item-avatar size="24" class="mr-2">
        <v-img v-if="item.avatar" :src="item.avatar" />
        <span v-else class="white--text font-weight-bold text-xs" :style="{ backgroundColor: getAvatarColor(item.code) }">
          {{ item.name.charAt(0).toUpperCase() }}
        </span>
      </v-list-item-avatar>
      <span>{{ item.name }} ({{ item.code }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'EmployeeAutocomplete',
  props: {
    value: {
      type: String,
      default: null
    },
    employees: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedEmployeeCode: this.value,
      employeeSearch: ''
    };
  },
  computed: {
    filteredEmployees() {
      if (!this.employeeSearch) return this.employees;
      
      const search = this.employeeSearch.toLowerCase();
      return this.employees.filter(emp => 
        emp.code.toLowerCase().includes(search) ||
        emp.name.toLowerCase().includes(search)
      );
    },
    loadingEmployees() {
      return this.loading;
    }
  },
  watch: {
    value(newVal) {
      this.selectedEmployeeCode = newVal;
    }
  },
  methods: {
    getAvatarColor(code) {
      const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE'];
      let hash = 0;
      for (let i = 0; i < code.length; i++) {
        hash = code.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    }
  }
}
</script>
